import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Button} from '@chekinapp/ui';
import {HighlightedTitle} from '@chekin/shared';
import {IVUnavailableNotice} from '@chekin/shared/guest-form';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';
import {useReservation} from 'context/reservation';
import {PageLayout} from 'components/PageLayout';

function IVUnavailableView() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {data: reservation} = useReservation();

  const handleBackToSummary = useCallback(() => {
    navigate(getFullPath(PATHS.guestRegistration), {replace: true});
  }, [navigate, getFullPath]);

  return (
    <PageLayout
      className="iv-unavailable-view"
      kicker={t('guest_registration')}
      title={<HighlightedTitle i18nKey="verification_unavailable_title" />}
      intro={t('iv_unavailable_intro')}
      backLabel={t('summary')}
      onBack={handleBackToSummary}
      mobileTitle={t('guest_registration_title')}
      dock={
        <Button
          onClick={handleBackToSummary}
          className="w-full max-w-[340px]"
          variant="outline"
        >
          {t('back_to_summary')}
        </Button>
      }
    >
      <IVUnavailableNotice checkInDate={reservation?.check_in_date} />
    </PageLayout>
  );
}

export {IVUnavailableView};
